import React, { useRef } from 'react';
var VeltCommentSidebarV2EmptyPlaceholder = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-empty-placeholder-v2", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2EmptyPlaceholder;
